<template>
  <div :class="[isFullScreen ? 'h-full' : 'content-wrapper']" class="bg-white dark:bg-darkblue-900 flex flex-col w-full relative">
    <slot name="header" />
    <article class="content flex flex-col flex-auto overflow-y-auto">
      <div class="w-full md:w-11.5/12 lg:max-w-detail lg:mr-auto">
        <div class="px-4 lg:px-10">
            <slot name="main" />
        </div>
      </div>
      <div class="table-tools sticky top-0 z-20 px-4 lg:px-10 bg-white dark:bg-darkblue-900">
        <slot name="table-header" />
        <div class="flex flex-col lg:flex-row justify-between items-center space-y-3 lg:space-y-0">
          <slot name="table-core" />
        </div>
        <slot name="table-tags" />
      </div>
      <div :class="{ 'table-actions-visible': tableTools }" class="overflow-hidden flex-grow table-kendo">
        <!-- pb-11 lg:pb-15 <div class="w-full lg:px-9"> aqui estaba antes tab-component</div> -->
        <slot name="table-component" />
      </div>
    </article>
    <slot name="layout-extend" />
  </div>
</template>
<script>
export default {
  name: 'layout-list-detail',
  props: {
    tableTools: {
      type: Boolean,
      default: false
    },
    isFullScreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
.content-wrapper {
  width: 100%;
  @include breakpoint(lg) {
    width: calc(100% - 18.125rem);
  }
}

.aside-is-collapsed {
  .content-wrapper {
    @include breakpoint(lg) {
      width: calc(100% - 4.5rem);
    }
  }
}

</style>
